export default "__VITE_ASSET__d2d0ab36__"